import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {  toast } from 'react-toastify';
import config from '../Config/Config';

export default function Favorites(props) {
    const { color, setColor} = props;
    let navigate = useNavigate();
    const [favlist, setFavlist] = useState([]);
    let token = localStorage.getItem("token");

    async function favData(){
        let response = await axios.get(config.apiUrlgetfav, {
            params : {_id: localStorage.getItem("id")}
        })
        console.log(response)
        setFavlist(response.data.favArr);
    }
    useEffect(() => {
        favData();
        if(token==null){
            toast('Login to proceed further', {
                position: "top-center",
                autoClose: 2000,
                type: "error",
                theme: "colored",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                })
            navigate('/login');
        }
    }, [])

    async function deleteFav(name){
        console.log(name)
        let response = await axios.put(config.apiUrlremovefav, {
            _id: localStorage.getItem("id"),
            name: name
        },
        {
            headers: {
                "Content-Type": "application/json"
            }, withCredentials: true
    
        },
        toast('Removed from favourites', {
            position: "top-center",
            autoClose: 2000,
            type: "error",
            theme:"colored",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            })
        );
        favData();
    }
 




    
    return (
        <div style={{marginTop:'100px'}} className='container'>
            {
                favlist.length==0?<h1 className='display-1 text-center text-muted'>No Items in the List</h1>: <h1 className="display-3 text-center text-muted"><i><b>Your Saved Coins</b></i></h1>

            }
            <div>
                <table className={`table table-${color} table-hover mt-3`}>
                    <thead>
                        <tr>
                            <th scope="col">COIN</th>
                            <th scope="col">PRICE</th>
                            <th scope="col">24h CHANGE</th>
                            <th scope="col">MARKET CAP</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        
                    {
                            favlist.map(item => 
                                <tr key={item.name}>
                                    <td scope="row"><img style={{height:"6vh"}} src={item.image}/><h6 className='mt-1'>{item.name}</h6></td>
                                    <td className=''>₹ {item.current_price.toLocaleString()}</td>
                                    <td style={{color: item.price_change_percentage_24h  > 0 ? "green":"red", fontWeight:500}}>{item.price_change_percentage_24h} % </td>
                                    <td>₹ {item.market_cap.toString().slice
                                                (0,-9)} M</td>
                                    <td> <i title='Delete item' className="fa-solid fa-trash" onClick={()=> deleteFav(item.name)}></i> </td>
                                    
                                    
                                </tr>
                            )
                        }

                    </tbody>
                </table>
            </div>
            <button className={color=='light'?'btn btn-warning':'btn btn-outline-warning'} onClick={()=> navigate('/home')}> <i className="fa-solid fa-arrow-left-long"></i> Back</button>
        </div>
    )
}

// onClick={() => navigate(`/coin/${item.id}`)}
// style={{ color: item.price_change_percentage_24h > 0 ? "green" : "red", fontWeight: 500 }}
